export default "__VITE_ASSET__M0tFOPxf__"